import type { CSSProperties } from "react";

/**
 * Wireframe 4 · Placement. The reticle itself lives in the scene; this is the
 * instruction and the stability read-out that tells the visitor the surface is
 * about to be accepted.
 */
export function PlacementOverlay({ progress }: { progress: number }) {
  const ready = progress >= 1;
  return (
    <section className="placement-overlay" data-testid="placement">
      <div
        className="stability-ring"
        role="progressbar"
        aria-label="Surface detection"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(progress * 100)}
        style={{ "--placement-progress": progress } as CSSProperties}
      >
        <i />
      </div>
      <p className="placement-title">{ready ? "Tap to place" : "Looking for a surface"}</p>
      <p className="placement-hint" aria-live="polite">
        {ready ? "Tap where you want the object to sit." : "Move your phone slowly to find a surface"}
      </p>
    </section>
  );
}
